<is-shell>
  <router-outlet></router-outlet>
</is-shell>
